// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"106765a5","459":"f12e4914"}[chunkId] + ".chunk.js";
};